import {
  Directive,
  Inject,
  Input,
  OnInit,
  OnDestroy,
  signal
} from '@angular/core';

import { AccordionDirective } from './accordion.directive';

@Directive({
  selector: '[appAccordionLink]',
  standalone : true,
  // Bound to a signal so opens from outside an event (initial route check,
  // NavigationEnd) still repaint; a plain field left the class stale until
  // the next click, which then toggled it closed.
  host: { '[class.open]': '_open()' }
})
export class AccordionLinkDirective implements OnInit, OnDestroy {
  @Input()
  public group: any;

  @Input()
  get open(): boolean {
    return this._open();
  }

  set open(value: boolean) {
    this._open.set(value);
    if (value) {
      this.nav.closeOtherLinks(this);
    }
  }

  protected _open = signal(false);
  protected nav: AccordionDirective;

  constructor(@Inject(AccordionDirective) nav: AccordionDirective) {
    this.nav = nav;
  }

  ngOnInit(): any {
    this.nav.addLink(this);
  }

  ngOnDestroy(): any {
    this.nav.removeGroup(this);
  }

  toggle(): any {
    this.open = !this.open;
  }
}
